import { Control, Controller } from 'react-hook-form';

import { UserPreferredUnit } from '@data';
import { useTranslate } from '@i18n';
import { ToggleButtonCard, Stack, Text, u } from '@ui';

import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

import { optionGrid } from './CommonStyles.css';

const UNITS: UserPreferredUnit[] = ['metric', 'imperial', 'mixed'];

type UnitStepProps = {
    control: Control<UserWelcomeWizardForm>;
};

export const UnitStep = ({ control }: UnitStepProps) => {
    const t = useTranslate();

    return (
        <Controller
            control={control}
            name="userPreferredUnit"
            render={({ field }) => (
                <div className={optionGrid}>
                    {UNITS.map((unit) => (
                        <ToggleButtonCard
                            key={unit}
                            value={unit}
                            onClick={field.onChange}
                            isSelected={field.value === unit}
                        >
                            <Stack gap={u(1)} alignItems="flex-start">
                                <Text variant="h3" color="inherit">
                                    {t(`menu.user_settings_unit_${unit}`)}
                                </Text>
                                <Text variant="pSmall" color="inherit">
                                    {t(`user_welcome_wizard.unit_options_description_${unit}`)}
                                </Text>
                            </Stack>
                        </ToggleButtonCard>
                    ))}
                </div>
            )}
        />
    );
};
